export const selectMyLocation = (state) => state.location.location;
export const selectLocationStatus = (state) => state.location.status;
